import { combineReducers } from "redux";
import { routerReducer } from "react-router-redux";
import step from "./step";
import inquires from "./inquires";
import restIntel from "./restIntel";
import lead from "./lead";

export default combineReducers({
  routing: routerReducer,
  step,
  inquires,
  restIntel,
  lead
});


// WEBPACK FOOTER //
// ./src/reducers/index.js